import { Box, iconButtonClasses, styled } from "@mui/material";

import { Container as TopbarContainer } from "fond/topBar/TopBar.styles";

export const Container = styled(TopbarContainer)`
  padding-right: ${({ theme }) => theme.spacing(2)};

  .${iconButtonClasses.root} {
    margin-right: ${({ theme }) => theme.spacing(1)};
  }
`;

export const Title = styled(Box)`
  margin-left: ${({ theme }) => theme.spacing(2)};
`;
